export const TestHooks = {
	FirstName: 'first-name',
	LastName: 'last-name',
	Email: 'email',
	CompanyName: 'company-name',
	Address: 'address',
	PhoneNumber: 'phone-number',
} as const;
